module.exports = __webpack_public_path__ + "static/media/l_itdot_11.218c7b7a.png";